<template>
    <div>
        <h1>{{ $t('site.playerSelection.changeUser') }}</h1>
        <div class="row">
            <div class="col-md-8">
                <elv-player-search-box :jumpToEnabled="true" :emitViewAsPlayer="true"/>
            </div>
        </div>

        <!-- Remove Once footer is fixed -->
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>


    </div>

</template>

<script>
    import ElvFellowshipSearchBox from "@/components/ElvPlayerSearchBox";
    import axios from 'axios';
    import ElvPlayerSearchBox from "../components/ElvPlayerSearchBox"

    export default {
        components: {ElvPlayerSearchBox},
        name: 'Players',
        data () {
            return {
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/ChangePlayer.vue